export default "__VITE_ASSET__CVl9R3XX__"